<template>
  <div
    v-show="visible"
    class="m-popup-nickname"
  >
    <div class="nickname-title">
      Please enter your Nickname :
    </div>

    <div
      class="nickname-input"
      :class="{
        'active': nickname,
        'error': inputStatus === 'error'
      }"
    >
      <VInput
        v-model.trim="nickname"
        autofocus
        clearable
        @input="onInput"
      />
    </div>

    <div class="nickname-error">
      <p v-show="errorText">
        {{ errorText }}
      </p>
    </div>

    <NicknameRule class="nickname-rules" />

    <div class="nickname-area" />

    <div class="dialog--footer horizontal">
      <a
        class="btn btn--cancel"
        @click="cancle"
      >
        SKIP
      </a>
      <a
        class="btn btn--ok"
        :class="{
          'disabled': !nickname,
          'loading': createLoading
        }"
        @click="ok"
      >
        <svg
          v-if="createLoading"
          class="loading-icon"
          viewBox="0 0 1024 1024"
          p-id="2096"
          width="30"
          height="30"
        ><path
          d="M96 512c0-19.33 15.67-35 35-35s35 15.67 35 35c0 191.09 154.91 346 346 346s346-154.91 346-346-154.91-346-346-346c-19.33 0-35-15.67-35-35s15.67-35 35-35c229.75 0 416 186.25 416 416S741.75 928 512 928 96 741.75 96 512z"
          p-id="2097"
        /></svg>
        CREATE
      </a>
    </div>
  </div>
</template>

<script>
import VInput from 'fe-vui/input'
import toast from 'fe-vui/toast'
import { useUserStore } from '@ms/stores/user'
import axios from 'crypto-fetch/axios'
import NicknameRule from '@ms/components/NicknameRule.vue'

export default {
  name: 'Nickname',
  components: {
    VInput,
    NicknameRule
  },
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      nickname: null,
      inputStatus: 'default',
      errorText: '',
      createLoading: false
    }
  },
  methods: {
    async setNickname() {
      try {
        this.createLoading = true
        const { nickname } = this
        await axios.put(`/gossip/comments/nickName/set?nickName=${nickname}`)
        toast('Nickname set successfully !')
        useUserStore().setNickname(nickname)
        localStorage.setItem('m_nickname', nickname)
        this.$emit('onSuccess', nickname)
        this.createLoading = false
      } catch (error) {
        const { message } = error
        if (error.bizCode) {
          this.inputStatus = 'error'
          this.errorText = message
        } else {
          toast(message)
        }
        this.createLoading = false
      }
    },
    onInput(val) {
      val = val.trim()
      if (val.length > 15) {
        this.nickname = val.slice(0, 15)
        this.inputStatus = 'error'
        this.errorText = 'Nickname, enter up to 15 characters.'
      } else {
        this.nickname = val.slice(0, 15)
        this.inputStatus = 'default'
        this.errorText = ''
      }
    },
    cancle() {
      this.nickname = null
      this.inputStatus = 'default'
      this.errorText = ''
      // 存local
      this.$emit('onClose')
    },
    ok() {
      if (this.nickname) {
        this.setNickname()
      }
    }
  }
}
</script>
<style lang="less">
@import url("~wap/common/style/variable.less");

.m-popup-nickname {
  width: 100%;
  padding-top: 30/@rem;
  border-radius: 4px;
  background: #f8f8f8;

  .nickname-title {
    width: 220/280 * 100%;
    margin: 0 auto;
    color: @major;
    font-size: 20/@rem;
    line-height: 24/@rem;
    text-align: center;
  }

  .nickname-input {
    width: 220/280 * 100%;
    margin: 5/@rem auto;

    .v-input-wrap {
      height: 32/@rem;
      padding: 0 4/@rem;
      border: 1px solid #666;
      border-radius: 16px;
      background: @white;
    }

    .v-input-wrap.focus {
      border: 1px solid #267dff;
    }

    .v-input,
    input {
      height: 32/@rem;
      caret-color: #267dff;
    }

    &.active {
      .v-input-wrap {
        border: 1px solid #267dff;
      }
    }

    &.error {
      .v-input-wrap {
        border: 1px solid #e51717;
      }

      .v-input-wrap.focus {
        border: 1px solid #e51717;
      }

      input {
        caret-color: #e51717;
      }
    }

    .v-input--append {
      display: flex;
      margin-right: 2px;

      .v-input--clear .icon {
        position: relative;
        top: -1px;
        width: 13px;
        height: 13px;
      }
    }
  }

  .nickname-error {
    width: 190/280 * 100%;
    height: 30/@rem;
    margin: 0 auto;
    color: #e51717;
    font-size: 10/@rem;
    line-height: 10/@rem;
  }

  .nickname-rules {
    width: 220/280 * 100%;
    max-height: 200/@rem;
    margin: 0 auto;
    overflow-y: scroll;
    text-align: left;

    & > h4 {
      margin-bottom: 10/@rem;
      color: @major;
      font-size: 14/@rem;
      line-height: 16/@rem;
    }

    & > p {
      position: relative;
      margin-top: 6/@rem;
      color: @normal;
      font-size: 12/@rem;
      line-height: 14/@rem;
      text-indent: 6/@rem;
    }

    & > p:last-child {
      margin-left: 0/@rem;
      text-indent: 0/@rem;
    }

    & > p:not(:last-child)::before {
      position: absolute;
      top: 5/@rem;
      left: 0/@rem;
      width: 2/@rem;
      height: 2/@rem;
      border-radius: 50%;
      background: @normal;
      content: "";
    }
  }

  .nickname-area {
    width: 100%;
    height: 36/@rem;
  }

  .btn.disabled {
    color: #999;
  }

  .btn.loading {
    border: 1px solid #fff0c4;
    background: #fff0c4;
    color: #666;
  }

  .loading-icon {
    width: 14px;
    margin-top: -2px;
    margin-right: 6px;
    animation: circles 0.85s linear infinite;
    fill: #999;
    vertical-align: middle;
  }

  @keyframes circles {
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
